import React from 'react';
import { ViewMode } from '../constants';

interface PreviewContainerProps {
  children: React.ReactNode;
  view: ViewMode;
  isPreview?: boolean;
}

export function PreviewContainer({ children, view, isPreview = true }: PreviewContainerProps) {
  if (!isPreview) {
    // Render as a normal web page (no device frame)
    return <div className="w-full h-full">{children}</div>;
  }

  return (
    <div className={
      view === ViewMode.MOBILE
        ? '@container w-[390px] max-w-full h-full bg-transparent rounded-[32px] shadow-[0px_2px_6px_-4px_rgba(0,0,0,0.12)] shadow-[0px_4px_8px_0px_rgba(93,105,116,0.08)] shadow-[0px_8px_24px_8px_rgba(93,105,116,0.05)] outline outline-1 outline-offset-[-1px] outline-gray-400 overflow-hidden relative'
        : '@container w-full max-w-[1200px] h-full rounded-[32px] shadow-lg outline outline-1 outline-offset-[-1px] outline-gray-300 overflow-hidden relative'
    }
    >
      {/* Device Frame */}
      <div className="absolute inset-0 bg-white rounded-[inherit]">
        {/* Scrollable Content */}
        <div className={`w-full h-full overflow-y-auto ${view === ViewMode.MOBILE ? 'rounded-b-[32px]' : 'rounded-[32px]'}`}>
          {children}
        </div>
      </div>
    </div>
  );
}
